const TabData01 = [
  {
    tabTitle: "INTELLIGENT TRAFFIC SYSTEM (ITS)",
    subtitle: "Hệ thống điều khiển tín hiệu giao thông",
    tabicons: "",
    title: "CROSS TRAFFIC CONTROL",
    link: "/traffic-control",
    id: "traffic-control",
    components: [
      {
        title: "Traffic Control System",
        //subtitle: 'Hệ thống điều khiển tín hiệu giao thông',
        content:
          "inMeeting is the strategic partner for urban traffic signal control solutions provided by Cross (Czech Republic), including Cross RS4(s) signal controllers installed at intersections and the eDaptiva urban traffic management system. The integrated solution enables continuous real-time monitoring of vehicle traffic flow at intersections, which in turn provides the necessary data for the system to calculate and implement optimal traffic signal control strategies. These strategies are then applied in a synchronized manner to improve traffic flow across both local areas and the broader urban network.",
        img: "/assets/img/webp/IMT_TrafficControl.jpg",
        buttonTitle: "Software datasheet",
        buttonLink:
          "/assets/datasheet/edaptiva_datasheet_cross_ds_edaptiva_eng_0421.pdf",
        buttonTitle1: "Controller datasheet",
        buttonLink1: "/assets/datasheet/rs_4_datasheet_eng_0521.pdf",
      },
      {
        title: "Weigh-In-Motion System (WIM)",
        //subtitle: 'Hệ thống kiểm tra tải trọng xe tự động không dừng',
        content:
          "inMeeting is the strategic partner for the high-speed, non-stop Weigh-In-Motion (WIM) system - CrossWIM, in Vietnam. This is the first WIM system to be officially approved for direct enforcement of overweight violations in the Czech Republic since 2011. The system offers a measurement accuracy of ±5% for total vehicle weight (when verified), with 100% reliability. \n\nCrossWIM utilizes industrial-grade sensors to comprehensively capture vehicle data, including individual wheel load, axle load, gross vehicle weight, vehicle speed, vehicle classification, license plate number, dimensions, axle spacing, and more — fully meeting the technical requirements of current national standards. \n\ninMeeting is fully prepared to integrate the CrossWIM system with urban traffic management solutions, following each project’s specifications and requirements.",
        img: "/assets/img/webp/IMT_WIM.jpg",
        buttonTitle: "WIM Datasheet",
        buttonLink:
          "/assets/datasheet/Datasheet_cross_ds_crosswim_22_02_21_eng_digital.pdf",
      },
      {
        title: "Parking",
        //subtitle: 'Hệ thống thu phí đỗ xe',
        content:
          "inMeeting is proud to partner with CROSS, a global pioneer in modern parking technologies, to bring innovative and intelligent parking solutions to Vietnam. As urbanization accelerates and parking demands rise, our collaboration delivers next-generation systems designed to maximize space utilization, enhance operational efficiency, and elevate user convenience. From busy urban centers to commercial complexes, airports, and residential areas, Inmeeting implements CROSS’s flexible and scalable solutions—including license plate recognition, cashless payments, and real-time space monitoring—to revolutionize parking management. \n\nWith a commitment to seamless integration and forward-thinking innovation, Inmeeting tailors CROSS’s proven technologies to meet Vietnam’s unique needs. Our solutions help reduce traffic congestion, simplify parking operations, and provide diverse payment options, all while supporting the country’s smart city development goals.",
        img: "/assets/img/webp/parking.jpg",
        // buttonTitle: "Parking Datasheet",
        // buttonLink: "/assets/datasheet/Datasheet_cross_ds_crosswim_22_02_21_eng_digital.pdf"
      },
    ],
  },

  {
    tabTitle: "SURVEILLANCE",
    //subtitle: 'Hệ thống camera giám sát',
    tabicons: "",
    id: "surveillance",
    components: [
      {
        title: "Large Scale Surveillance",
        //subtitle: 'Hệ thống giám sát diện rộng',
        content:
          "At inMeeting, we specialize in delivering cutting-edge, city-wide monitoring solutions designed to empower governments, municipalities, and urban planners with real-time insights, enhanced public safety, and smarter infrastructure management. From traffic control and environmental sensing to security surveillance and emergency response coordination, our scalable systems provide the reliability and precision needed to keep modern cities running smoothly. \n\nWith state-of-the-art technology and a data-driven approach, Inmeeting ensures seamless monitoring across vast urban landscapes-turning critical data into actionable intelligence. Whether optimizing traffic flow, improving air quality, or enhancing public security, our solutions help cities operate more efficiently and sustainably.",
        img: "/assets/img/webp/surveillance1.jpg",
        // buttonTitle: "DATASHEET IMSTOR-S4202",
        // buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        // buttonTitle1: "DATASHEET IMSTOR-P8214",
        // buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
      {
        title: "AI Analysis",
        //subtitle: 'Hệ thống phân tích bằng AI',
        content:
          "At inMeeting, we pioneer advanced AI-powered face recognition and behavior analysis solutions designed to transform security, operations, and customer experiences. Our cutting-edge technology delivers real-time identity verification, actionable insights, and predictive analytics-empowering  governments, and organizations to enhance safety, optimize efficiency, and make data-driven decisions. \n\ninMeeting’s AI-driven face recognition and behavior analysis empower public agencies with real-time identity verification, crowd intelligence, and predictive threat detection-enhancing national security, urban safety, and civic services. From law enforcement to smart city management, our technology detects anomalies, identifies persons of interest, and analyzes crowd dynamics to prevent incidents before they escalate. By transforming surveillance into actionable intelligence, we help governments protect citizens, optimize resources, and build trust through transparency.",
        img: "/assets/img/webp/face.jpeg",
        // buttonTitle: "DATASHEET IMSTOR-S4202",
        // buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        // buttonTitle1: "DATASHEET IMSTOR-P8214",
        // buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
    ],
  },
  {
    tabTitle: "Medical Imaging",
    //subtitle: "Hệ thống chẩn đoán hình ảnh",
    tabicons: "",
    content: "",
    id: "medical-imaging",
    components: [
      {
        title: "Picture Archiving and Communication System (PACs)",
        //subtitle: 'Hệ thống chẩn đoán bệnh bằng hình ảnh',
        content:
          "inMeeting takes pride in delivering cutting-edge Picture Archiving and Communication Systems (PACS) designed to revolutionize medical imaging workflows. Our secure, scalable, and AI-enhanced solutions empower hospitals, clinics, and diagnostic centers to streamline image storage, enhance diagnostic accuracy, and improve patient care—all while ensuring compliance with global healthcare standards. \n\nWith inMeeting’s PACS, healthcare providers gain seamless access to DICOM images, real-time collaboration tools, and advanced analytics, enabling faster decision-making and more precise treatments. From radiology and cardiology to telemedicine and teleradiology, our platform integrates effortlessly with existing systems, reducing costs and boosting efficiency across the entire care continuum.",
        img: "/assets/img/webp/pacs.jpg",
        // buttonTitle: "SOFTWARE DATASHEET",
        // buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        // buttonTitle1: "HARDWARE DATASHEET",
        // buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
      {
        title: "AI Assisted Diagnosis",
        // subtitle: 'Hệ thống chẩn đoán bệnh bằng hình ảnh',
        content:
          "inMeeting is proud to present our advanced AI Assistant for Medical Diagnosis, a transformative solution designed to elevate clinical decision-making and streamline diagnostic workflows. This intelligent system combines the power of artificial intelligence with flexible integration options, offering healthcare providers the choice of a fully comprehensive PACS solution or seamless compatibility with existing PACS infrastructure. \n\nOur AI assistant enhances diagnostic accuracy through sophisticated image analysis, reduces interpretation times, and supports healthcare professionals in delivering more confident, data-driven diagnoses. Whether you're looking to implement a complete AI-powered diagnostic ecosystem or enhance your current systems, our solution adapts to your facility's unique needs while maintaining the highest standards of data security and compliance.",
        img: "/assets/img/webp/medical_AI.jpg",
        // buttonTitle: "SOFTWARE DATASHEET",
        // buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        // buttonTitle1: "HARDWARE DATASHEET",
        // buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf"
      },
    ],
  },
  {
    tabTitle: "SAN STORAGE",
    //subtitle: 'Hệ thống lưu trữ chuyên dụng cho CCTV và Chẩn đoán hình ảnh',
    tabicons: "",
    id: "san-storage",
    title: "IMSTOR",
    img: "/assets/img/webp/IMT_SAN.jpg",
    content:
      "IMSTOR hệ thống lưu trữ mạng (SAN), điều khiển bởi hệ điều hành SDS Raidix, là một hệ thống với thiết kế scale-out, cho phép nhanh chóng mở rộng và tăng cường khả năng truy nhập dữ liệu của các hệ thống video surveillance qui mô lớn, đồng thời cắt giảm đáng kế chi phí đầu tư cũng như đảm bảo tính an toàn của dữ liệu. Chuyên dụng cho video và dữ liệu lớn, không tính năng thừa, chỉ có công suất thô thật lớn và an toàn dữ liệu ở mức cao nhất, khả năng sao lưu và đồng bộ dữ liệu thời gian thực, từ 100TB-4PB cho một hệ thống độc lập, đảm bảo lưu trữ và truy xuất cho 5000 camera FHD trên một hệ thống độc lập. Hệ thống SAN do InMeeting sản xuất gồm: IMSTOR-S4202 (single controller), IMSTOR-P8214 (dual controller)",

    components: [
      {
        title: "IMSTOR",
        //subtitle: 'Hệ thống lưu trữ chuyên dụng cho CCTV và Chẩn đoán hình ảnh',
        content:
          "IMSTOR is a network storage system (SAN) powered by the SDS Raidix operating system. It features a scale-out architecture that enables rapid expansion and enhances data access performance for large-scale video surveillance systems while minimizing investment cost. The system is designed specifically for video and big data applications, the system eliminates unnecessary features, focusing instead on delivering massive raw capacity and the highest levels of data security. It supports real-time data backup and synchronization, offering storage capacities ranging from 100TB to 4PB per standalone system — apable of storing and retrieving footage from up to 5,000 Full HD cameras on a single system. The SAN system, developed by InMeeting, includes the following models: IMSTOR-S4202 (single controller) and IMSTOR-P8214 (dual controller).",
        img: "/assets/img/webp/IMT_SAN.jpg",
        buttonTitle: "DATASHEET IMSTOR-S4202",
        buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        buttonTitle1: "DATASHEET IMSTOR-P8214",
        buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
    ],
  },
  // {
  //     tabTitle: 'WIM',
  //     subtitle: 'Hệ thống kiểm tra tải trọng xe tự động không dừng',
  //     tabicons: "",
  //     title: 'CrossWIM',
  //     img: '/assets/img/webp/IMT_WIM.jpg',
  //     content: 'INMEETING là đối tác triển khai hệ thống cân tải trọng không dừng tốc độ cao CrossWIM tại Việt Nam. Đây là hệ thống WIM đầu tiên được cấp phép ứng dụng cho hoạt động xử phạt trực tiếp (Direct Enforcement) lỗi vi phạm tải trọng tại CH Séc từ năm 2011, với Độ chuẩn xác khi kiểm định của phép đo tổng tải trọng là +/-5%, độ tin cậy 100%. Hệ thống sử dụng bộ cảm biến chuẩn công nghiệp giúp thu thập đầy đủ dữ liệu về phương tiện được kiểm tra: tải trọng từng bánh, từng trục và tổng tải trọng xe, tốc độ xe, phân loại xe, biển số xe, kích thước xe, khoảng cách các trục ... đáp ứng yêu cầu kỹ thuật của quy chuẩn quốc gia hiện hành. INMEETING  sẵn sàng tích hợp CrossWIM với hệ thống quản lý điều hành giao thông theo yêu cầu của dự án. ',
  //     buttonTitle: "Datasheet",
  //     buttonLink: "/assets/datasheet/Datasheet_cross_ds_crosswim_22_02_21_eng_digital.pdf"
  // },

  // {
  //     tabTitle: 'TRAFFIC ANALYTICS',
  //     subtitle: 'Hệ thống thu thập dữ liệu giao thông',
  //     tabicons: "",
  //     title: 'TRAFFIC ANALYTICS',
  //     img: '/assets/img/webp/IMT_TrafficAnalytics.jpg',
  //     content: 'Mọi giải pháp quản lý điều hành giao thông đều dựa trên cơ sở là khả năng đo đếm chính xác lưu lượng và các thuộc tính khác của luồng phương tiện như : phân loại, tốc độ trung bình, tỷ lệ chiếm dụng mặt đường. Các loại cảm biến truyền thống trong lĩnh vực giao thông như vòng cảm ứng từ, radar có nhiều hạn chế về khả năng triển khai và thu thập dữ liệu  trong điều kiện giao thông phức tạp tại Việt Nam. Vì vậy INMEETING xây dựng giải pháp giao thông theo hướng  ứng dụng công nghệ trí tuệ nhân tạo và xử lý hình ảnh video từ camera để trích xuất các dữ liệu thống kê giao thông, phát hiện các sự cố và điều kiện bất thường trong đô thị cũng như trên cao tốc để tự động cảnh báo cho nhà quản lý.  Hệ thống được thiết kế để đảm bảo khả năng quan sát, phân tích 24/7, đáp ứng yêu cầu về độ chính xác theo các tiêu chuẩn áp dụng tại Việt Nam. INMEETING thực hiện tích hợp dữ liệu phân tích giao thông với các hệ thống khác theo yêu cầu của từng khách hàng và dự án. ',
  //     buttonTitle: "Datasheet",
  //     buttonLink: "mailto:info@inmeeting.com.vn"
  // }
];

const TabData02 = [
  {
    tabTitle: "Development",
    tabicons: "ti-light-bulb",
    subtitle:
      "Transform your ideas. We know that good design means good business.",
    img: "https://via.placeholder.com/800x550",
    title:
      "We are idea driven, working with a strong focus on design and user experience.",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud exercitation ullamco laboris.",
    buttonTitle: "watch a projects",
    buttonLink: "#",
  },
  {
    tabTitle: "Performance",
    tabicons: "ti-timer",
    img: "https://via.placeholder.com/800x550",
    title:
      "We are idea driven, working with a strong focus on design and user experience.",
    subtitle:
      "Transform your ideas. We know that good design means good business.",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud exercitation ullamco laboris.",
    buttonTitle: "watch a projects",
    buttonLink: "#",
  },
  {
    tabTitle: "Analytics",
    tabicons: "ti-pie-chart",
    img: "https://via.placeholder.com/800x550",
    title:
      "We are idea driven, working with a strong focus on design and user experience.",
    subtitle:
      "Transform your ideas. We know that good design means good business.",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud exercitation ullamco laboris.",
    buttonTitle: "watch a projects",
    buttonLink: "#",
  },
  {
    tabTitle: "Concept",
    tabicons: "ti-crown",
    img: "https://via.placeholder.com/800x550",
    title:
      "We are idea driven, working with a strong focus on design and user experience.",
    subtitle:
      "Transform your ideas. We know that good design means good business.",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, nostrud exercitation ullamco laboris.",
    buttonTitle: "watch a projects",
    buttonLink: "#",
  },
];

const TabData03 = [
  {
    tabTitle: "STARTERS",
    tabicons: "",
    activities: [
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Green salad",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$06.00",
        img: "https://via.placeholder.com/73x73",
        title: "Grilled chicken tenders",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Crepes of wrath",
        content: "Printing and typesetting industry",
        author: "",
        badge: {
          title: "new",
          color: "#70a967",
        },
      },
      {
        price: "$06.00",
        img: "https://via.placeholder.com/73x73",
        title: "Chicken breast burger",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser blatter",
        content: "Ipsum is simply dolor text printing",
        author: "Printing and typesetting industry",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives ",
        content: "Ipsum is simply dolor text printing",
        author: "",
        badge: {
          title: "hot",
          color: "#d74a3a",
        },
      },
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives",
        content: "Printing and typesetting industry",
        author: "",
      },
      {
        price: "$07.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser platter",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
    ],
  },
  {
    tabTitle: "NONVEG",
    tabicons: "",
    activities: [
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser blatter",
        content: "Lorem ipsum has been the industry",
        author: "",
      },
      {
        price: "$02.00",
        img: "https://via.placeholder.com/73x73",
        title: "Chicken breast burger",
        content: "Printing and typesetting industry",
        author: "",
      },
      {
        price: "$04.00",
        img: "https://via.placeholder.com/73x73",
        title: "Green salad",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$07.00",
        img: "https://via.placeholder.com/73x73",
        title: "Grilled chicken tenders",
        content: "Lorem ipsum has been the industry",
        author: "",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Crepes of wrath ",
        content: "Printing and typesetting industry",
        author: "",
        badge: {
          title: "new",
          color: "#70a967",
        },
      },
      {
        price: "$09.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives",
        content: "Ipsum is simply dolor text printing",
        author: "",
        badge: {
          title: "hot",
          color: "#d74a3a",
        },
      },
      {
        price: "$02.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives",
        content: "Lorem ipsum has been the industry",
        author: "",
      },
      {
        price: "$03.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser platter",
        content: "Printing and typesetting industry",
        author: "",
      },
    ],
  },
  {
    tabTitle: "VEGETARIAN",
    tabicons: "",
    activities: [
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Green salad",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$06.00",
        img: "https://via.placeholder.com/73x73",
        title: "Grilled chicken tenders",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Crepes of wrath",
        content: "Printing and typesetting industry",
        author: "",
        badge: {
          title: "new",
          color: "#70a967",
        },
      },
      {
        price: "$06.00",
        img: "https://via.placeholder.com/73x73",
        title: "Chicken breast burger",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser blatter",
        content: "Ipsum is simply dolor text printing",
        author: "Printing and typesetting industry",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives ",
        content: "Ipsum is simply dolor text printing",
        author: "",
        badge: {
          title: "hot",
          color: "#d74a3a",
        },
      },
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives",
        content: "Printing and typesetting industry",
        author: "",
      },
      {
        price: "$07.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser platter",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
    ],
  },
  {
    tabTitle: "DESSERT",
    tabicons: "",
    activities: [
      {
        price: "$02.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser blatter",
        content: "Lorem ipsum has been the industry",
        author: "",
      },
      {
        price: "$04.00",
        img: "https://via.placeholder.com/73x73",
        title: "Chicken breast burger",
        content: "Printing and typesetting industry",
        author: "",
      },
      {
        price: "$06.00",
        img: "https://via.placeholder.com/73x73",
        title: "Green salad",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Grilled chicken tenders",
        content: "Lorem ipsum has been the industry",
        author: "",
      },
      {
        price: "$03.00",
        img: "https://via.placeholder.com/73x73",
        title: "Crepes of wrath ",
        content: "Printing and typesetting industry",
        author: "",
        badge: {
          title: "new",
          color: "#70a967",
        },
      },
      {
        price: "$05.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives",
        content: "Ipsum is simply dolor text printing",
        author: "",
        badge: {
          title: "hot",
          color: "#d74a3a",
        },
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives",
        content: "Lorem ipsum has been the industry",
        author: "",
      },
      {
        price: "$03.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser platter",
        content: "Printing and typesetting industry",
        author: "",
      },
    ],
  },
  {
    tabTitle: "DRINKS",
    tabicons: "",
    activities: [
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Green salad",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$06.00",
        img: "https://via.placeholder.com/73x73",
        title: "Grilled chicken tenders",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Crepes of wrath",
        content: "Printing and typesetting industry",
        author: "",
        badge: {
          title: "new",
          color: "#70a967",
        },
      },
      {
        price: "$06.00",
        img: "https://via.placeholder.com/73x73",
        title: "Chicken breast burger",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser blatter",
        content: "Ipsum is simply dolor text printing",
        author: "Printing and typesetting industry",
      },
      {
        price: "$08.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives ",
        content: "Ipsum is simply dolor text printing",
        author: "",
        badge: {
          title: "hot",
          color: "#d74a3a",
        },
      },
      {
        price: "$10.00",
        img: "https://via.placeholder.com/73x73",
        title: "Spicy mixed olives",
        content: "Printing and typesetting industry",
        author: "",
      },
      {
        price: "$07.00",
        img: "https://via.placeholder.com/73x73",
        title: "Appeteaser platter",
        content: "Ipsum is simply dolor text printing",
        author: "",
      },
    ],
  },
];

const TabData05 = [
  {
    tabTitle: "MONDAY",
    tabicons: "",
    activities: [
      {
        accordionid: "accordion-style-5-1",
        accordionhref: "#accordion-style-5-1",
        time: "06:00 - 07:00",
        title: "Yoga and pilates",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-2",
        accordionhref: "#accordion-style-5-2",
        time: "08:00 - 09:00",
        title: "Energy blast",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
      {
        accordionid: "accordion-style-5-3",
        accordionhref: "#accordion-style-5-3",
        time: "10:00 - 11:00",
        title: "Cardio workout",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Jeremy dupont",
      },
      {
        accordionid: "accordion-style-5-4",
        accordionhref: "#accordion-style-5-4",
        time: "11:00 - 12:00",
        title: "Athletics classes",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Edward watson",
      },
      {
        accordionid: "accordion-style-5-5",
        accordionhref: "#accordion-style-5-5",
        time: "13:00 - 15:00",
        title: "Boxercise",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Bryan jonhson",
      },
    ],
  },
  {
    tabTitle: "TUESDAY",
    tabicons: "",
    activities: [
      {
        accordionid: "accordion-style-5-1",
        accordionhref: "#accordion-style-5-1",
        time: "06:00 - 07:00",
        title: "Energy blast",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-2",
        accordionhref: "#accordion-style-5-2",
        time: "08:00 - 09:00",
        title: "Yoga and pilates",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
      {
        accordionid: "accordion-style-5-3",
        accordionhref: "#accordion-style-5-3",
        time: "10:00 - 11:00",
        title: "Cardio workout",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Jeremy dupont",
      },
      {
        accordionid: "accordion-style-5-4",
        accordionhref: "#accordion-style-5-4",
        time: "12:00 - 13:00",
        title: "Boxercise",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-5",
        accordionhref: "#accordion-style-5-5",
        time: "13:00 - 14:00",
        title: "Athletics classes",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
    ],
  },
  {
    tabTitle: "WEDNESDAY",
    tabicons: "",
    activities: [
      {
        accordionid: "accordion-style-5-1",
        accordionhref: "#accordion-style-5-1",
        time: "06:00 - 07:00",
        title: "Yoga and pilates",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-2",
        accordionhref: "#accordion-style-5-2",
        time: "08:00 - 09:00",
        title: "Energy blast",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
      {
        accordionid: "accordion-style-5-3",
        accordionhref: "#accordion-style-5-3",
        time: "10:00 - 11:00",
        title: "Cardio workout",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Jeremy dupont",
      },
      {
        accordionid: "accordion-style-5-4",
        accordionhref: "#accordion-style-5-4",
        time: "11:00 - 12:00",
        title: "Athletics classes",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Edward watson",
      },
      {
        accordionid: "accordion-style-5-5",
        accordionhref: "#accordion-style-5-5",
        time: "13:00 - 15:00",
        title: "Boxercise",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Bryan jonhson",
      },
    ],
  },
  {
    tabTitle: "THURSDAY",
    tabicons: "",
    activities: [
      {
        accordionid: "accordion-style-5-1",
        accordionhref: "#accordion-style-5-1",
        time: "06:00 - 07:00",
        title: "Energy blast",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-2",
        accordionhref: "#accordion-style-5-2",
        time: "08:00 - 09:00",
        title: "Yoga and pilates",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
      {
        accordionid: "accordion-style-5-3",
        accordionhref: "#accordion-style-5-3",
        time: "10:00 - 11:00",
        title: "Cardio workout",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Jeremy dupont",
      },
      {
        accordionid: "accordion-style-5-4",
        accordionhref: "#accordion-style-5-4",
        time: "12:00 - 13:00",
        title: "Boxercise",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-5",
        accordionhref: "#accordion-style-5-5",
        time: "13:00 - 14:00",
        title: "Athletics classes",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
    ],
  },
  {
    tabTitle: "FRIDAY",
    tabicons: "",
    activities: [
      {
        accordionid: "accordion-style-5-1",
        accordionhref: "#accordion-style-5-1",
        time: "06:00 - 07:00",
        title: "Yoga and pilates",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-2",
        accordionhref: "#accordion-style-5-2",
        time: "08:00 - 09:00",
        title: "Energy blast",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
      {
        accordionid: "accordion-style-5-3",
        accordionhref: "#accordion-style-5-3",
        time: "10:00 - 11:00",
        title: "Cardio workout",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Jeremy dupont",
      },
      {
        accordionid: "accordion-style-5-4",
        accordionhref: "#accordion-style-5-4",
        time: "11:00 - 12:00",
        title: "Athletics classes",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Edward watson",
      },
      {
        accordionid: "accordion-style-5-5",
        accordionhref: "#accordion-style-5-5",
        time: "13:00 - 15:00",
        title: "Boxercise",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Bryan jonhson",
      },
    ],
  },
  {
    tabTitle: "SATURDAY",
    tabicons: "",
    activities: [
      {
        accordionid: "accordion-style-5-1",
        accordionhref: "#accordion-style-5-1",
        time: "06:00 - 07:00",
        title: "Energy blast",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-2",
        accordionhref: "#accordion-style-5-2",
        time: "08:00 - 09:00",
        title: "Yoga and pilates",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
      {
        accordionid: "accordion-style-5-3",
        accordionhref: "#accordion-style-5-3",
        time: "10:00 - 11:00",
        title: "Cardio workout",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: " By Jeremy dupont",
      },
      {
        accordionid: "accordion-style-5-4",
        accordionhref: "#accordion-style-5-4",
        time: "12:00 - 13:00",
        title: "Boxercise",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Edward watson",
      },
      {
        accordionid: "accordion-style-5-5",
        accordionhref: "#accordion-style-5-5",
        time: "13:00 - 14:00",
        title: "Athletics classes",
        content:
          "Lorem ipsum is simply dummy text of the printing and typesetting industry lorem ipsum.",
        author: "By Bryan jonhson",
      },
    ],
  },
];

const TabData06 = [
  {
    tabTitle: "MONDAY",
    day: "01 DAY",
    tabicons: "",
    activities: [
      {
        time: "09:00 - 10:00",
        img: "https://via.placeholder.com/197x197",
        title: "Cultures of creativity",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "10:00 - 12:30",
        img: "https://via.placeholder.com/197x197",
        title: "Reinventing experiences",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "12:30 - 05:30",
        img: "https://via.placeholder.com/197x197",
        title: "Human centered design",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
    ],
  },
  {
    tabTitle: "TUESDAY",
    day: "02 DAY",
    tabicons: "",
    activities: [
      {
        time: "09:00 - 10:00",
        img: "https://via.placeholder.com/197x197",
        title: "Cultures of creativity",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "10:00 - 12:30",
        img: "https://via.placeholder.com/197x197",
        title: "Reinventing experiences",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "12:30 - 05:30",
        img: "https://via.placeholder.com/197x197",
        title: "Human centered design",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
    ],
  },
  {
    tabTitle: "WEDNESDAY",
    day: "03 DAY",
    tabicons: "",
    activities: [
      {
        time: "09:00 - 10:00",
        img: "https://via.placeholder.com/197x197",
        title: "Cultures of creativity",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "10:00 - 12:30",
        img: "https://via.placeholder.com/197x197",
        title: "Reinventing experiences",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "12:30 - 05:30",
        img: "https://via.placeholder.com/197x197",
        title: "Human centered design",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
    ],
  },
  {
    tabTitle: "THURSDAY",
    day: "04 DAY",
    tabicons: "",
    activities: [
      {
        time: "09:00 - 10:00",
        img: "https://via.placeholder.com/197x197",
        title: "Cultures of creativity",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "10:00 - 12:30",
        img: "https://via.placeholder.com/197x197",
        title: "Reinventing experiences",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "12:30 - 05:30",
        img: "https://via.placeholder.com/197x197",
        title: "Human centered design",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
    ],
  },
  {
    tabTitle: "FRIDAY",
    day: "05 DAY",
    tabicons: "",
    activities: [
      {
        time: "09:00 - 10:00",
        img: "https://via.placeholder.com/197x197",
        title: "Cultures of creativity",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "10:00 - 12:30",
        img: "https://via.placeholder.com/197x197",
        title: "Reinventing experiences",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
      {
        time: "12:30 - 05:30",
        img: "https://via.placeholder.com/197x197",
        title: "Human centered design",
        content:
          "Lorem ipsum is simply dummy text of the and typesetting industry lorem ipsum.",
        author: "By Edward Watson",
      },
    ],
  },
];

const TabData07 = [
  {
    tabTitle: "Turnaround consulting",
    featurebox: [
      {
        icon: "line-icon-Bakelite text-[#bf8c4c] text-[50px]",
        title: "Operational excellence",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
      {
        icon: "line-icon-Medal-2 text-[#bf8c4c] text-[50px]",
        title: "Innovative solutions",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
    ],
    title: "Turnaround consulting",
    subtitle: "Can your business become better with new technology?",
    img: "https://via.placeholder.com/456x481",
    buttonTitle: "Discover service",
    buttonLink: "/page/our-services",
    tabicons: "",
  },
  {
    tabTitle: "Strategic planning",
    featurebox: [
      {
        icon: "line-icon-Archery-2 text-[#bf8c4c] text-[50px]",
        title: "Consulting strategies",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
      {
        icon: "line-icon-Bar-Chart2 text-[#bf8c4c] text-[50px]",
        title: "Customer satisfaction",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
    ],
    title: "Strategic planning",
    subtitle: "We work to ensure that your business prospers and brings",
    img: "https://via.placeholder.com/456x481",
    buttonTitle: "Discover service",
    buttonLink: "/page/our-services",
    tabicons: "",
  },
  {
    tabTitle: "Investment planning",
    featurebox: [
      {
        icon: "line-icon-Coins text-[#bf8c4c] text-[50px]",
        title: "Finance and restructuring",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
      {
        icon: "line-icon-Coins-3 text-[#bf8c4c] text-[50px]",
        title: "Strategy and planning",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
    ],
    title: "Investment planning",
    subtitle: "Can your business become better with new technology?",
    img: "https://via.placeholder.com/456x481",
    buttonTitle: "Discover service",
    buttonLink: "/page/our-services",
    tabicons: "",
  },
  {
    tabTitle: "Expense reporting",
    featurebox: [
      {
        icon: "line-icon-Idea-5 text-[#bf8c4c] text-[50px]",
        title: "Business consulting",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
      {
        icon: "line-icon-Globe text-[#bf8c4c] text-[50px]",
        title: "Innovative solutions",
        content:
          "Lorem ipsum is simply dummy text of the printing typesetting ipsum been text.",
      },
    ],
    title: "Expense reporting",
    subtitle: "We work to ensure that your business prospers and brings",
    img: "https://via.placeholder.com/456x481",
    buttonTitle: "Discover service",
    buttonLink: "/page/our-services",
    tabicons: "",
  },
];
const TabDataTraffic = [
  {
    tabTitle: "INTELLIGENCE TRAFFIC SYSTEM (ITS)",
    subtitle: "Hệ thống điều khiển tín hiệu giao thông",
    tabicons: "",
    title: "CROSS TRAFFIC CONTROL",
    components: [
      {
        title: "Traffic Control System",
        subtitle: "Hệ thống điều khiển tín hiệu giao thông",
        content:
          "One of the best traffic light controllers, which can operate decentralizedly, in coordination or connected to the traffic management center. ",
        img: "/assets/img/webp/IMT_TrafficControl.jpg",
        buttonTitle: "Software datasheet",
        buttonLink:
          "/assets/datasheet/edaptiva_datasheet_cross_ds_edaptiva_eng_0421.pdf",
        buttonTitle1: "Controller datasheet",
        buttonLink1: "/assets/datasheet/rs_4_datasheet_eng_0521.pdf",
      },
      {
        title: "Weigh-In-Motion System (WIM)",
        subtitle: "Hệ thống kiểm tra tải trọng xe tự động không dừng",
        content:
          "WIM systems allow vehicles to be weighed and traffic data to be analyzed without stopping the vehicles. They help protect roads from damage caused by overloaded vehicles and contribute to increased traffic safety.",
        img: "/assets/img/webp/IMT_WIM.jpg",
        buttonTitle: "WIM Datasheet",
        buttonLink:
          "/assets/datasheet/Datasheet_cross_ds_crosswim_22_02_21_eng_digital.pdf",
      },
      {
        title: "Parking",
        subtitle: "Hệ thống thu phí đỗ xe",
        content: "Thu tiền đỗ xe là đam mê của chúng tôi",
        img: "/assets/img/webp/parking.jpg",
        buttonTitle: "Parking Datasheet",
        buttonLink:
          "/assets/datasheet/Datasheet_cross_ds_crosswim_22_02_21_eng_digital.pdf",
      },
    ],
  },
  {
    tabTitle: "SAN STORAGE",
    subtitle: "Hệ thống lưu trữ chuyên dụng cho CCTV và Chẩn đoán hình ảnh",
    tabicons: "",
    title: "IMSTOR",
    img: "/assets/img/webp/IMT_SAN.jpg",
    content:
      "IMSTOR hệ thống lưu trữ mạng (SAN), điều khiển bởi hệ điều hành SDS Raidix, là một hệ thống với thiết kế scale-out, cho phép nhanh chóng mở rộng và tăng cường khả năng truy nhập dữ liệu của các hệ thống video surveillance qui mô lớn, đồng thời cắt giảm đáng kế chi phí đầu tư cũng như đảm bảo tính an toàn của dữ liệu. Chuyên dụng cho video và dữ liệu lớn, không tính năng thừa, chỉ có công suất thô thật lớn và an toàn dữ liệu ở mức cao nhất, khả năng sao lưu và đồng bộ dữ liệu thời gian thực, từ 100TB-4PB cho một hệ thống độc lập, đảm bảo lưu trữ và truy xuất cho 5000 camera FHD trên một hệ thống độc lập. Hệ thống SAN do InMeeting sản xuất gồm: IMSTOR-S4202 (single controller), IMSTOR-P8214 (dual controller)",

    components: [
      {
        title: "IMSTOR",
        subtitle: "Hệ thống lưu trữ chuyên dụng cho CCTV và Chẩn đoán hình ảnh",
        content:
          "IMSTOR hệ thống lưu trữ mạng (SAN), điều khiển bởi hệ điều hành SDS Raidix, là một hệ thống với thiết kế scale-out, cho phép nhanh chóng mở rộng và tăng cường khả năng truy nhập dữ liệu của các hệ thống video surveillance qui mô lớn, đồng thời cắt giảm đáng kế chi phí đầu tư cũng như đảm bảo tính an toàn của dữ liệu. Chuyên dụng cho video và dữ liệu lớn, không tính năng thừa, chỉ có công suất thô thật lớn và an toàn dữ liệu ở mức cao nhất, khả năng sao lưu và đồng bộ dữ liệu thời gian thực, từ 100TB-4PB cho một hệ thống độc lập, đảm bảo lưu trữ và truy xuất cho 5000 camera FHD trên một hệ thống độc lập. Hệ thống SAN do InMeeting sản xuất gồm: IMSTOR-S4202 (single controller), IMSTOR-P8214 (dual controller)",
        img: "/assets/img/webp/IMT_SAN.jpg",
        buttonTitle: "DATASHEET IMSTOR-S4202",
        buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        buttonTitle1: "DATASHEET IMSTOR-P8214",
        buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
    ],
  },
  {
    tabTitle: "SURVEILLANCE",
    subtitle: "Hệ thống camera giám sát",
    tabicons: "",
    components: [
      {
        title: "Large Scale Surveillance",
        subtitle: "Hệ thống giám sát diện rộng",
        content:
          "At Inmeeting, we specialize in delivering cutting-edge, city-wide monitoring solutions designed to empower governments, municipalities, and urban planners with real-time insights, enhanced public safety, and smarter infrastructure management. From traffic control and environmental sensing to security surveillance and emergency response coordination, our scalable systems provide the reliability and precision needed to keep modern cities running smoothly. \n\nWith state-of-the-art technology and a data-driven approach, Inmeeting ensures seamless monitoring across vast urban landscapes-turning critical data into actionable intelligence. Whether optimizing traffic flow, improving air quality, or enhancing public security, our solutions help cities operate more efficiently and sustainably.",
        img: "/assets/img/webp/surveillance1.jpg",
        buttonTitle: "DATASHEET IMSTOR-S4202",
        buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        buttonTitle1: "DATASHEET IMSTOR-P8214",
        buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
      {
        title: "AI Analysis",
        subtitle: "Hệ thống phân tích bằng AI",
        content: "",
        img: "/assets/img/webp/surveillance1.jpg",
        buttonTitle: "DATASHEET IMSTOR-S4202",
        buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        buttonTitle1: "DATASHEET IMSTOR-P8214",
        buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
    ],
  },
  {
    tabTitle: "Medical Imaging",
    subtitle: "Hệ thống chẩn đoán hình ảnh",
    tabicons: "",
    content: "",
    img: "",
    components: [
      {
        title: "Picture Archiving and Communication System (PACs)",
        subtitle: "Hệ thống chẩn đoán bệnh bằng hình ảnh",
        content: "",
        img: "/assets/img/webp/pacs.jpg",
        buttonTitle: "SOFTWARE DATASHEET",
        buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        buttonTitle1: "HARDWARE DATASHEET",
        buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
      {
        title: "AI Assisted Diagnosis",
        subtitle: "Hệ thống chẩn đoán bệnh bằng hình ảnh",
        content: "",
        img: "/assets/img/webp/pacs.jpg",
        buttonTitle: "SOFTWARE DATASHEET",
        buttonLink: "/assets/datasheet/Datasheet-IMSTOR-S4202.pdf",
        buttonTitle1: "HARDWARE DATASHEET",
        buttonLink1: "/assets/datasheet/Datasheet-IMSTOR-P8214.pdf",
      },
    ],
  },
];
export {
  TabData01,
  TabData02,
  TabData03,
  TabData05,
  TabData06,
  TabData07,
  TabDataTraffic,
};
